import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Banner from '../sections/Banner/Banner';
import Emergency from '../sections/Emergency/Emergency';
import Features from '../sections/Features/Features';
import Footer from '../sections/Footer/Footer';
import Services from '../sections/Services/Services';
import Testimonial from '../sections/Testimonial/Testimonial';
const Home = () => {

    return (
        <>
            <Navbar/>
            <Banner/>
            <Emergency/>
            <Services/>     
            <Features />
            <Testimonial/>
            <Footer/>
        </>
    );
};

export default Home;